import { Content } from 'shared/components/Content';
import { SolveProblemsContainer } from '../SolveProblemsContainer';
import { ProtectYouContainer } from '../ProtectYouContainer';
import { AboutServiceBannerContainer } from '../AboutServiceBannerContainer';
import { FindTodayContainer } from '../FindTodayContainer';
import { HeaderContainer } from '../HeaderContainer';
import { ModalFormContainer } from '../ModalFormContainer';
import { useToggleState } from '@cian/react-utils';
import { ModalContext } from 'shared/utils/modalContext';
import { FormContainer } from '../FormContainer';

export const ContentContainer: React.FC = () => {
  const { state: modalVisible, toggle: toggleModalVisible } = useToggleState(false);

  return (
    <ModalContext.Provider value={modalVisible}>
      <Content
        onChangeVisibleModal={toggleModalVisible}
        header={<HeaderContainer onChangeModalVisible={toggleModalVisible} />}
        solveProblems={<SolveProblemsContainer />}
        protectYou={<ProtectYouContainer />}
        aboutService={<AboutServiceBannerContainer />}
        findToday={<FormContainer Form={FindTodayContainer} />}
        modal={<FormContainer Form={ModalFormContainer} onChangeModalVisible={toggleModalVisible} />}
      />
    </ModalContext.Provider>
  );
};
